export default __webpack_public_path__ + "02fbe2933cd301d311086d56149a06ad.jpg";